import React from 'react';
import { SitecoreImageField } from 'components/sitecore-fields';
import { isEmpty } from '../../../sso/components/utils/obj-utils';
import {
    calculateRemainingDate,
    checkIfExpired
} from '../helpers/toch-helpers';

class CountdownAlertBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            countdownTimer: Date.now(),
            days: null,
            minutes: null,
            hours: null
        };

        this.getRemainingDate = this.getRemainingDate.bind(this);
    }

    getRemainingDate() {
        const { countdownTimer } = this.props.data;
        const newDate = calculateRemainingDate(countdownTimer);

        this.setState({ days: newDate.days, hours: newDate.hours, minutes: newDate.minutes });
    }

    componentDidMount() {
        const { refreshTime } = this.props.data;
        const refresh = (isEmpty(refreshTime) || refreshTime === null || refreshTime === undefined) ? 60000 : refreshTime;

        this.interval = setInterval(() => this.getRemainingDate(), refresh);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const {
            countdownTimer,
            countdownDaysText,
            countdownHoursText,
            countdownMinutesText,
            link,
            linkText,
            logo,
            isInEditMode,
            text,
        } = this.props.data;
        const { days, hours, minutes } = this.state;

        const isExpired = checkIfExpired(countdownTimer);

        const newDate = (days === null && hours === null && minutes === null) ? calculateRemainingDate(countdownTimer) : null;
        const daysValue = (days === null || days === undefined) ? newDate.days : days;
        const hoursValue = (hours === null || hours === undefined) ? newDate.hours : hours;
        const minutesValue = (minutes === null || minutes === undefined) ? newDate.minutes : minutes;
 
        return (
            <div className="nav-alert-bar">
                    <div className="nav-alert-bar__text">
                        {text}
                        {
                            (!isExpired) &&
                              <span>
                                    <b> {daysValue} {countdownDaysText.toLowerCase()}, {hoursValue} {countdownHoursText.toLowerCase()}</b> and <b> {minutesValue} {countdownMinutesText.toLowerCase()} </b>
                              </span>
                        }
                    </div>
                <div>
                    {
                        (link.url !== null && link.url !== undefined) &&
                        <div>
                            {
                                (logo.src !== null && logo.src !== undefined) &&
                                <a className="nav-alert-bar__link" href={link.url}>
                                    <SitecoreImageField img={logo}></SitecoreImageField>
                                    {linkText}
                                </a>
                            }
                            {
                                (logo.src === null || logo.src === undefined) &&
                                <a className="nav-alert-bar__link" href={link.url}>
                                    {linkText}
                                </a>
                            }
                        </div>
                    }
                    {
                        (link.url === null || link.url === undefined) &&
                        <SitecoreImageField img={logo}></SitecoreImageField>
                    }
                </div>
            </div>
        );
    }
}

export default CountdownAlertBar;
